import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { CKEditor4 } from 'ckeditor4-angular/ckeditor';
import * as moment from 'moment';
import { Router } from '@angular/router';
@Component({
  selector: 'app-brand-hub',
  templateUrl: './brand-hub.component.html',
  styleUrls: ['./brand-hub.component.scss']
})
export class BrandHubComponent implements OnInit {
  brandhubTypes: any = [];
  brandhub: any = [];
  moreInfo: any;
  image: any = ""
  brandType: any = "";
  ModalName = "";
  getPaginationCount;
  totalPages;
  page = 1;
  Search = "";
  isSilde: boolean = false


  //editor code
  public editorConfig = {
    height: 300,
    toolbar: [
      ['Format', 'Font', 'FontSize'], ['Bold', 'Italic'], ['NumberedList', 'BulletedList'], ['JustifyLeft', 'JustifyCenter', 'JustifyRight'],
      ['Undo', 'Redo'], ['Maximize', 'Image'],
    ],
    extraPlugins: 'uploadimage',
    uploadUrl: this.apiConfig.uploadImages,
    filebrowserUploadMethod: 'form',
    filebrowserImageBrowseUrl: 'src/assets/imageViewer/',

    filebrowserImageUploadUrl: this.apiConfig.uploadImages,
    hidden: false
  }
  types: any;
  thumbnail: any = '';
  submitted: boolean = false
  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private toast: ToastClientService,
    private router: Router
  ) { }

  ngOnInit() {
    this.getBrandhubTypes();
    this.getBrandhub();
  }

  isSlideChange() {
    console.log(this.isSilde)
    this.isSilde = !this.isSilde
    console.log(this.isSilde)

  }


  getBrandhubTypes() {
    this.apiService.get(this.apiConfig.getBrandhubTypes).subscribe((res: any) => {
      console.log(res)
      this.brandhubTypes = res.data;
      // this.toast.Success(res.body.data.message)
    })
  }
  getBrandhub() {
    this.apiService.getHeaders(this.apiConfig.getBrandhub + `?brand_hub_type=${this.brandType}&page=${this.page}&search=${this.Search}`).subscribe((res: any) => {
      console.log(res)
      this.brandhub = res.body.data;
      this.getPaginationCount = res.headers.get("X-Pagination-Total-Count");
      this.totalPages = res.headers.get('X-Pagination-Per-Page')

    })
  }
  paginationClick(page) {
    this.page = page;
    this.getBrandhub();
  }

  reset() {
    this.brandType = '';
    this.Search = '';
    this.getBrandhub();
  }
  moreInformation(data, modal) {
    console.log(data)
    this.modalService.open(modal, {
      centered: true,
      size: 'lg'
    })
    this.moreInfo = data;
  }
  openBrandhubCreate() {
    let brandhubdeatails = {
      ModalName: 'create',
      brandHubid: 0
    }
    this.router.navigate([`/hubAdmin/brand-hub-setup/${brandhubdeatails.brandHubid}`])
    localStorage.setItem('brandhubdeatails', JSON.stringify(brandhubdeatails))
  }

  editBrandhub(data) {
    let brandhubdeatails = {
      ModalName: 'edit',
      brandHubid: data.id,
      editData: data
    }
    this.router.navigate([`/hubAdmin/brand-hub-setup/${brandhubdeatails.brandHubid}`])
    localStorage.setItem('brandhubdeatails', JSON.stringify(brandhubdeatails))
  }


  deleteBrandHub(data) {
    let payload = {
      program_id: 1,
      brand_hub_id: data.id
    }
    console.log(payload)
    this.apiService.post(this.apiConfig.deleteBrandhub, payload).subscribe((res: any) => {
      this.getBrandhub();
      this.toast.Success(res.body.data.message)
      this.dismissModal();
      console.log(res)
    })

  }
  dismissModal() {
    this.modalService.dismissAll();
  }
}
